<button class="btn btn-success dropdown-toggle" type="button" data-toggle="dropdown" [disabled]="websiteUrl?.IsReadOnly || restrictions.includes(customerCampaignRestrictionTypes_ReadOnly)"
  [ngClass]="{'btn-success': websiteUrl.StatusId === websiteUrlStatuses_Target, 'btn-primary': websiteUrl.StatusId === websiteUrlStatuses_Supporting, 'btn-secondary': websiteUrl.StatusId === websiteUrlStatuses_New }">
  <ng-container *ngIf="websiteUrl.StatusId === websiteUrlStatuses_Target">Target</ng-container>
  <ng-container *ngIf="websiteUrl.StatusId === websiteUrlStatuses_Supporting">Supporting</ng-container>
  <ng-container *ngIf="websiteUrl.StatusId === websiteUrlStatuses_New">New</ng-container>
</button>
<ul class="dropdown-menu" role="menu">
  <ng-container *ngIf="websiteUrl.StatusId === websiteUrlStatuses_Target">
    <li>
      <button class="btn-link dropdown-item" (click)="updateWebsiteUrlStatus(websiteUrl, websiteUrlStatuses_New)">New</button>
    </li>
    <li>
      <button class="btn-link dropdown-item" (click)="updateWebsiteUrlStatus(websiteUrl, websiteUrlStatuses_Supporting)">Supporting</button>
    </li>
    <li>
      <button class="btn-link dropdown-item disabled">Target</button>
    </li>
  </ng-container>
  <ng-container *ngIf="websiteUrl.StatusId === websiteUrlStatuses_Supporting">
    <li>
      <button class="btn-link dropdown-item" (click)="updateWebsiteUrlStatus(websiteUrl, websiteUrlStatuses_New)">New</button>
    </li>
    <li>
      <button class="btn-link dropdown-item disabled">Supporting</button>
    </li>
    <li>
      <button class="btn-link dropdown-item" (click)="updateWebsiteUrlStatus(websiteUrl, websiteUrlStatuses_Target)">Target</button>
    </li>
  </ng-container>
  <ng-container *ngIf="websiteUrl.StatusId === websiteUrlStatuses_New">
    <li>
      <button class="btn-link dropdown-item disabled">New</button>
    </li>
    <li>
      <button class="btn-link dropdown-item" (click)="updateWebsiteUrlStatus(websiteUrl, websiteUrlStatuses_Supporting)">Supporting</button>
    </li>
    <li>
      <button class="btn-link dropdown-item" (click)="updateWebsiteUrlStatus(websiteUrl, websiteUrlStatuses_Target)">Target</button>
    </li>
  </ng-container>
  <div class="dropdown-divider"></div>
  <li>
    <button class="btn-link dropdown-item" (click)="updateWebsiteUrlStatus(websiteUrl, websiteUrlStatuses_Archived)">Archive</button>
  </li>
</ul>